import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Column, ColumnContainer, Divider, SectionTitle, TileSlider, TitleContainer } from "@beacharound/beacharound-ui";
import { formatDate, getProductImage } from '@beacharound/beacharound-ui-helpers';

import { getBeachProductsByDates } from "../../api/beach";
import { useQuery } from "react-query";

export default function BeachesProductsSlider({hasMap, isBookable, match}) {

    const { beachSlug } = match.params;
    
    const productOptions = {
        fromDate: formatDate(new Date(), "yyyy-MM-dd"), 
        toDate: formatDate(new Date(), "yyyy-MM-dd")
    }
    const { data: products } = useQuery(["products", beachSlug, productOptions], () =>
        getBeachProductsByDates({slug: beachSlug, params: productOptions}),
        {
            enabled: !hasMap,
            refetchOnWindowFocus: false
        }
    )

    if(!products || products.length <= 0) {
        return <Fragment></Fragment>
    }

    return (
        <ColumnContainer noMargin>
            <Column>
                <TitleContainer>
                    <SectionTitle text="Prodotti disponibili oggi" />
                </TitleContainer>
                <ColumnContainer noMargin>
                    <Column>
                        <TileSlider slides={products.map(item => {
                            let payload = {
                                image: item?.parentItem?.type && getProductImage(item.parentItem.type),
                                title: item?.parentItem?.name,
                                pretitle: item.remaining < 15 && `Solo ${item.remaining} disponibili!`,
                                text: `A partire da ${item.activityPrices?.[0]?.value}€`
                            }

                            if(isBookable) {
                                payload = {
                                    ...payload,
                                    containerComponent: Link,
                                    containerLink: `/prenotazione/spiaggia/${beachSlug}/date`
                                }
                            }

                            return payload;
                        })} />
                    </Column>
                </ColumnContainer>
                <Divider  />
            </Column>
        </ColumnContainer>
    );
}